import React, { ChangeEvent } from 'react';
import { Link } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import Tabs from '../widgets/tab/Tabs';
import Dialog from '../../toolkit/dialog';
import Content from '../dashboard/Content';
import NodeAction from './node/NodeAction';
import TabPane from '../widgets/tab/TabPane';
import Logger from '../../toolkit/logger/Logger';
import groupService from '../../services/group-service';
import sensorService from '../../services/sensor-service';
import EditGroupDialog from './dialogs/EditGroupDialog';
import CreateGroupDialog from './dialogs/CreateGroupDialog';
import RemoveGroupDialog from './dialogs/RemoveGroupDialog';
import ChangeParentDialog from './dialogs/ChangeParentDialog';
import ChangePermissionDialog from './dialogs/ChangePermissionDialog';
import { Input } from '../widgets/beauty';
import { NodeRow } from './node/NodeItem';
import { errorAlert } from '../../utils/alert';
import { getCurrentUser } from '../../utils/auth';
import { extractRouteById } from '../../utils/group';

import './EditGroups.scss';

const SELECT_GROUPED = 'GROUPED';
const SELECT_UNGROUPED = 'UNGROUPED';
const SELECT_LIMIT_MAX = 50;
const SELECT_LIMIT_WARNING = 45;

const EditGroupColumn = (props: any) => {
  return (
    <div className="section-column">
      {props.children}
    </div>
  );
}

interface State {
  pathId: string | null;
  sensors: any[];
  groups: any[];
  selectedType: string | null;
  searchGrouped: string;
  searchUngrouped: string;
  selected: {
    _id: string,
    type: 'sensor' | 'group';
  }[];
}

interface Props extends RouteComponentProps<{ group: string }> {
}

export default class EditGroupsPage extends React.Component<Props, State> {

  state = {
    test: false,
    pathId: this.props.match.params.group ?? null,
    sensors: [],
    groups: [],
    selected: [],
    selectedType: null,
    searchGrouped: '',
    searchUngrouped: ''
  }

  private prefs = {} as any;
  private queryParams: URLSearchParams = null;

  /** @override */
  constructor(props: Props) {
    super(props);
    this.queryParams = new URLSearchParams(this.props.location.search);
  }


  /** @override */
  render() {
    this.prefs = this.getSelectPrefs();
    const currentGroup = this.getCurrentGroup();
    const hasParent = !(currentGroup == null);
    const query = this.props.location.search;

    return (
      <Content title="ویرایش گروه بندی‌">
        {this.renderBackToShowGroups()}
        <div className="row edit-groups-component" style={{ margin: '0 0.25rem' }}>
          <div className="col-xl-5 col-12" style={{ maxHeight: 'calc(100% + 0.5rem)' }}>
            <EditGroupColumn>
              <Tabs defaultActive="1">
                <TabPane key="1" text="بدون دسته بندی">
                  <Input.SearchBox
                    dir="rtl"
                    placeholder="جستجو..."
                    value={this.state.searchUngrouped}
                    onChange={this.handleUngroupedSearchChange} />
                  {this.renderUngroupedSensors()}
                </TabPane>
                <TabPane key="2" text="دسته بندی شده">
                  <Input.SearchBox
                    dir="rtl"
                    placeholder="جستجو..."
                    value={this.state.searchGrouped}
                    onChange={this.handleGroupedSearchChange} />
                  {this.renderGroupedSensors()}
                </TabPane>
              </Tabs>
            </EditGroupColumn>
          </div>
          <div className="col-xl-2 col-12">
            <div className="column-mover">
              {this.renderMoverButtons()}
            </div>
          </div>
          <div className="col-xl-5 col-12 h-100">
            <EditGroupColumn>
              <div className="section-grouped">
                <div className="bar top-bar ltr">
                  <Link
                    to={{ pathname: this.getParentLink(), search: query }}
                    className={'back-button' + (!hasParent ? ' disabled' : '')}>
                    <i className="far fa-lg fa-arrow-circle-left"></i>
                  </Link>
                  <span className="title">
                    <span className="group-name">{this.getCurrentGroupName()}</span>
                    <span className="address">{this.getCurrentAddress()}</span>
                  </span>
                </div>
                <div className="content">
                  {this.renderGroupedSection()}
                </div>
                <div className="bar bottom-bar">
                  {this.renderToolbar()}
                </div>
              </div>
            </EditGroupColumn>
          </div>
        </div>
      </Content>
    );
  }

  /** @override */
  componentDidMount = async () => {
    const user = getCurrentUser();
    const response = await groupService.fetchData(user._id, user.parent ?? user._id);
    const { sensors, groups } = response;
    Logger.info('EditGroupsPage::Groups =>', groups)
    Logger.info('EditGroupsPage::Sensors =>', sensors)
    this.setState({ sensors, groups });
  }

  /** @override */
  componentDidUpdate = () => {
    const { pathId, selectedType } = this.state;
    const group = this.props.match.params.group ?? null;
    if (pathId !== group) {
      const update: any = { pathId: group };
      if (selectedType === SELECT_GROUPED) {
        update.selectedType = null;
        update.selected = [];
      }
      this.setState(update);
      this.componentDidMount();
    }
  }

  renderBackToShowGroups = () => {
    const query = this.queryParams;
    if (!query.has('back')) {
      return '';
    }
    const backId = query.get('back');
    let url = '/dashboard/groups';
    if (backId) {
      url += '/' + backId
    }

    return (
      <div className="row" style={{ margin: '0 2rem' }}>
        <div className="col-12 px-0">
          <Link to={url} className="ant-btn ant-btn-lg">
            <span><i className="far fa-arrow-right"></i></span>
            <span className="mr-2">بازگشت به نمایش</span>
          </Link>
        </div>
      </div>
    );
  }

  renderMoverButtons = () => {
    const { pathId, selected } = this.state;
    const {
      isSelected, hasGroup,
      isGroupedSelected, isUngroupedSelected
    } = this.prefs;

    let removeDisabled: any, assignDisabled: any;

    if (!isSelected) {
      removeDisabled = assignDisabled = { disabled: true };
    }
    else {
      removeDisabled = (hasGroup || isUngroupedSelected) ? { disabled: true } : {};
      assignDisabled = (pathId === null || isGroupedSelected) ? { disabled: true } : {};
    }

    let color = 'rgb(69, 148, 233)';
    if (selected.length >= SELECT_LIMIT_MAX) {
      color = '#C0392B';
    }
    else if (selected.length > SELECT_LIMIT_WARNING) {
      color = '#FFD05B';
    }
    const selectedContent = selected.length < 1 ? '' : (
      <span style={{ color, fontWeight: 500 }}>{selected.length}/{SELECT_LIMIT_MAX}</span>
    );

    return (
      <>
        <button
          className="btn"
          {...removeDisabled}
          onClick={this.handleMoveButtonClicked.bind(this, null)}>
          <i className="far fa-times ml-2"></i>
          حذف از این گروه
        </button>
        <button
          className="btn"
          {...assignDisabled}
          onClick={this.handleMoveButtonClicked.bind(this, this.state.pathId)}>
          انتقال به این گروه
          <i className="far fa-hand-point-left mr-2"></i>
        </button>
        <div style={{ height: '50px' }} className="mt-3">
          {selectedContent}
        </div>
      </>
    );
  }

  renderGroupedSection = () => {
    const { selectedType } = this.state;
    const isGrouped = selectedType === SELECT_GROUPED;

    const groups = this.takeCurrentGroups().map(x => (
      <NodeRow
        key={x._id}
        id={x._id}
        text={x.name}
        type="group"
        onCheck={this.handleGroupedSelected}
        checked={isGrouped && this.findGroupInSelected(x) != null}
        query={this.props.location.search} />
    ));

    const sensors = this.takeCurrentSensors().map(x => (
      <NodeRow
        key={x._id}
        id={x._id}
        type="sensor"
        text={this.makeRowText(x._id, x.name)}
        onCheck={this.handleGroupedSelected}
        checked={isGrouped && this.findSensorInSelected(x) != null} />
    ));

    if (sensors.length > 0 || groups.length > 0) {
      return [...groups, ...sensors];
    }
    return (
      <div className="col-12 mt-3">
        <div className="alert alert-primary">
          چیزی در این گروه یافت نشد.
        </div>
      </div>
    );
  }

  renderToolbar = () => {
    const { prefs } = this;
    return (
      <div className="toolbar ltr">
        <NodeAction
          text="ساخت گروه"
          icon="far fa-plus-square"
          onClick={this.handleActionCreateGroup}
          color="rgb(243, 156, 18)" />
        <NodeAction
          text="حذف"
          icon="far fa-trash-alt"
          color="rgb(231, 76, 60)"
          onClick={this.handleActionRemoveGroup}
          disabled={prefs.hasSensor || !prefs.isGroupedSelected} />
        <NodeAction
          text="انتقال گروه"
          icon="far fa-box-open"
          color="rgb(52, 152, 219)"
          onClick={this.handleActionChangeParent}
          disabled={prefs.hasSensor || !prefs.isGroupedSelected} />
        <NodeAction
          text="سطوح دسترسی"
          icon="far fa-key-skeleton"
          color="rgb(142, 68, 173)"
          onClick={this.handleActionChangePermission}
          disabled={prefs.hasSensor || !prefs.isSingleGroupedSelected} />
        <NodeAction
          text="ویرایش گروه"
          icon="far fa-edit"
          color="rgb(22, 160, 133)"
          onClick={this.handleActionEditGroup}
          disabled={prefs.hasSensor || !prefs.isSingleGroupedSelected} />

      </div>
    );
  }

  renderGroupedSensors = () => {
    const { groups } = this.state;
    return this.takeGroupedSensors().map(x => (
      <NodeRow
        key={x._id}
        id={x._id}
        type="sensor"
        text={this.makeRowText(x._id, x.name)}
        noCheckbox={true}
        meta={extractRouteById(x.group._id, groups, '/Root/')}
        metaClasses="text-success"
      />
    ));
  }

  renderUngroupedSensors = () => {
    const { isUngroupedSelected } = this.prefs;
    const sensors = this.takeUngroupedSensors();
    const isAllSelected = sensors.length === this.state.selected.length;
    return [
      <NodeRow
        key={'all'}
        id={null}
        type=""
        text={<span style={{ color: '#777', fontSize: '0.95rem' }}>انتخاب همه</span>}
        onCheck={this.handleSelectAllUnGrouped}
        checked={isUngroupedSelected && isAllSelected}
      />,
      ...sensors.map(x => (
        <NodeRow
          key={x._id}
          id={x._id}
          type="sensor"
          text={this.makeRowText(x._id, x.name)}
          onCheck={this.handleUngroupedSelected}
          checked={isUngroupedSelected && this.findSensorInSelected(x) != null}
        />
      ))
    ];
  }

  handleGroupedSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchGrouped: e.target.value });
  }

  handleUngroupedSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchUngrouped: e.target.value });
  }

  handleGroupedSelected = (key: string, type: string) => {
    const { selectedType } = this.state;
    const callback = this.updateSelectedState.bind(this, key, type);
    if (selectedType === SELECT_GROUPED) {
      return callback();
    }
    return this.setState({ selectedType: SELECT_GROUPED, selected: [] }, callback);
  }

  handleUngroupedSelected = (key: string, type: string) => {
    const { selectedType } = this.state;
    const callback = this.updateSelectedState.bind(this, key, type);
    if (selectedType === SELECT_UNGROUPED) {
      return callback();
    }
    return this.setState({ selectedType: SELECT_UNGROUPED, selected: [] }, callback);
  }

  handleSelectAllUnGrouped = () => {
    const sensors = this.takeUngroupedSensors();
    if (this.state.selected.length !== sensors.length) {
      this.setState({
        selectedType: SELECT_UNGROUPED,
        selected: sensors.map(x => ({ _id: x._id, type: 'sensor' })) as any[]
      });
    }
    else {
      this.setState({ selected: [], selectedType: SELECT_UNGROUPED });
    }
  }

  handleMoveButtonClicked = async (groupId: string) => {
    const { selected } = this.state;
    try {
      await sensorService.updateGroup(selected, groupId);
      this.setState({ selected: [], selectedType: null });
      this.componentDidMount();
    }
    catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        errorAlert(e.response.data.message).show();
      }
    }
  }

  handleActionCreateGroup = () => {
    new Dialog({
      rtl: true,
      title: 'برای ایجاد گروه اطلاعات زیر را تکمیل کنید',
      message: CreateGroupDialog,
      onResolve: this.requestCreateGroup
    }).show();
  }

  handleActionRemoveGroup = () => {
    new Dialog({
      rtl: true,
      size: 'small',
      showTitle: false,
      message: RemoveGroupDialog,
      onResolve: this.requestRemoveGroups
    }).show();
  }

  handleActionChangePermission = () => {
    const { selected, groups } = this.state;
    const id = selected[0]._id;
    const group = groups.find(group => group._id === id);
    const title = 'ویرایش گروه ' + group?.name;
    new Dialog({
      rtl: true,
      title: title,
      message: ChangePermissionDialog,
      onResolve: this.requestChangeSupervisors
    }).show({ groupId: id });
  }

  handleActionChangeParent = () => {
    const { groups, selected } = this.state;
    new Dialog({
      rtl: true,
      size: 'small',
      title: 'گروه مقصد را انتخاب کنید',
      message: ChangeParentDialog,
      onResolve: this.requestChangeParent
    }).show({ groups, selected })
  }

  handleActionEditGroup = () => {
    const { selected, groups } = this.state;
    const id = selected[0]._id;
    const group = groups.find(group => group._id === id);
    const title = 'ویرایش گروه ' + group?.name;
    new Dialog({
      rtl: true,
      title: title,
      message: EditGroupDialog,
      onClose: () => this.componentDidMount()
    }).show({ groupId: id });
  }

  private takeCurrentGroups = () => {
    const { groups, pathId } = this.state;
    return groups.filter(x => x.parent === pathId);
  }

  private takeCurrentSensors = () => {
    const { sensors, pathId } = this.state;
    return sensors.filter(item => item.group != null && item.group._id === pathId);
  }

  private takeGroupedSensors = () => {
    const { sensors, searchGrouped } = this.state;
    const search = searchGrouped.trim();
    return sensors.filter(x => {
      if (x.group === null) return false;
      if (search === '') return true;
      return (
        x._id.toLowerCase().includes(search) ||
        x.name.toLowerCase().includes(search)
      );
    });
  }

  private takeUngroupedSensors = () => {
    const { sensors, searchUngrouped } = this.state;
    const search = searchUngrouped.trim();
    return sensors.filter(x => {
      if (x.group !== null) return false;
      if (search === '') return true;
      return (
        x._id.toLowerCase().includes(search) ||
        x.name.toLowerCase().includes(search)
      );
    });
  }

  private findGroupInSelected = (resource: any) => {
    const { selected } = this.state;
    return selected.find(item => item.type === 'group' && item._id === resource._id);
  }

  private findSensorInSelected = (resource: any) => {
    const { selected } = this.state;
    return selected.find(item => item.type === 'sensor' && item._id === resource._id);
  }

  private getCurrentGroup = () => {
    const { groups, pathId } = this.state;
    return groups.find(g => g._id === pathId);
  }

  private getCurrentGroupName = () => {
    const group = this.getCurrentGroup();
    return group == null ? 'Root' : group.name;
  }

  private getCurrentAddress = () => {
    const { pathId, groups } = this.state;
    return extractRouteById(pathId, groups, '/root/');
  }

  private makeRowText = (id: string, name: string) => {
    return (
      <>
        <span>{id}</span>
        <span className="spacer">-</span>
        <span>{name}</span>
      </>
    );
  }

  private getParentLink = () => {
    const group = this.getCurrentGroup();
    if (group == null || group.parent == null) {
      return '/dashboard/edit-groups';
    }
    return `/dashboard/edit-groups/${group.parent}`;
  }

  private getSelectPrefs = () => {
    const { selected, selectedType } = this.state;
    const isSelected = selected.length > 0;
    const isGrouped = selectedType === SELECT_GROUPED;
    const isUngrouped = selectedType === SELECT_UNGROUPED;
    const hasSensor = selected.find(item => item.type === 'sensor') != null;
    const hasGroup = selected.find(item => item.type === 'group') != null;
    return {
      hasGroup,
      hasSensor,
      isSelected,
      isGrouped,
      isUngrouped,
      isGroupedSelected: isSelected && isGrouped,
      isUngroupedSelected: isSelected && isUngrouped,
      isSingleGroupedSelected: selected.length === 1 && isGrouped
    }
  }

  private updateSelectedState = (key: string, type: string) => {
    const { selected } = this.state;
    const findIndex = selected.findIndex(x => x._id === key);
    let newSelected = [...selected];
    if (findIndex < 0) {
      newSelected.push({ _id: key, type });
    }
    else {
      newSelected.splice(findIndex, 1);
    }
    if (newSelected.length > SELECT_LIMIT_MAX) {
      return;
    }
    this.setState({ selected: newSelected });
  }

  private requestCreateGroup = async (result: any) => {
    const { pathId: parent } = this.state;
    const payload = { ...result, ...{ parent } };
    try {
      await groupService.create(payload);
      this.componentDidMount();
    }
    catch (e) {
      console.log(e);
      errorAlert('مشکلی در ایجاد گروه وجود دارد.').show();
    }
  }

  private requestRemoveGroups = async (result: any) => {
    if (!result) return;
    const { selected } = this.state;
    for (const item of selected) {
      await groupService.remove(item._id);
    }
    this.setState({ selected: [], selectedType: null }, this.componentDidMount);
  }

  private requestChangeSupervisors = async ({ groupId, data }) => {
    try {
      await groupService.updateSupervisors(groupId, data);
      this.setState({ selected: [], selectedType: null }, this.componentDidMount);
    }
    catch (e) {
      console.log(e);
    }
  }

  private requestChangeParent = async ({ selected, parent }) => {
    try {
      for (const item of selected) {
        await groupService.changeParent(item._id, parent);
      }
    }
    catch (e) {
      console.log(e);
    }
    this.componentDidMount();
  }

}
